import {
    memo, FC, useState,
    useEffect, useRef
} from 'react';

import styles from './styles.module.css';
import { HiOutlineSearch } from "react-icons/hi";
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

interface SearchProp {
    focus?: boolean;
    placeholder?: string;
    action?: (value: string) => any; // The dynamic action creator
}

const Search: FC<SearchProp> = ({ focus, placeholder, action }) => {
    const { i18n } = useTranslation();
    const [searchTerm, setSearchTerm] = useState<string>('');
    const dispatch = useDispatch();
    const inputRef = useRef<HTMLInputElement>(null);


    useEffect(() => {
        const handler = setTimeout(() => {
            if (action) {
                dispatch(action(searchTerm));
            }
        }, 500); // 500ms debounce time

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm, action, dispatch]);

    const searchOnChangeHandle = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };

    useEffect(() => {
        if (focus && inputRef.current) {
            inputRef.current.focus();
        }
    }, [focus]);

    return (
        <div className={styles.search}>
            <div className={`input-group ${styles.input__group}`}>
                <div className={styles.iconCon}>
                    <HiOutlineSearch size={22} />
                </div>
                <div className={styles.divider}></div>
                <input
                    type="text"
                    className="form-control search-input"
                    placeholder={placeholder || (i18n.language.includes("ar") ? "البحث..." : "Search...")}
                    aria-label="Search"
                    aria-describedby="button-addon2"
                    onChange={searchOnChangeHandle}
                    ref={inputRef}
                />
            </div>
        </div>
    );
};

export default memo(Search);
